import { useCallback } from "react";
import Web3 from "web3"; // ✅ Use Web3 directly
import { CrashGameContract } from "../../utils/contractHelpers";
import { CRASH_GAME_CONTRACT } from "../../utils/Enviroment";

const TotalLiquidity = () => {
  // ✅ Create Web3 instance directly using RPC (without wallet)
  const web3 = new Web3(
    "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
  );
  const contractAddress = CRASH_GAME_CONTRACT;

  const TotalLiquidityHook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = helper(addresss, web3);
        const balance = await contract?.methods?.totalLiquidity()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching totalLiquidity:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  const TotalWinningHook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = helper(addresss, web3);
        const balance = await contract?.methods?.totalWinnings()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching totalWinnings:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  const TotalVolumeHook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = helper(addresss, web3);
        const balance = await contract?.methods?.totalVolume()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching totalVolume:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  const JackpotHook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = helper(addresss, web3);
        const balance = await contract?.methods?.jackpot()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching jackpot:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  const baughtBackhook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = helper(addresss, web3);
        const balance = await contract?.methods?.buyBackAndBurnAmount()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching buybackandburn:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  const TotalRewardhook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = helper(addresss, web3);
        const balance = await contract?.methods?.totalRewards()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "mwei");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching buybackandburn:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  return {
    TotalLiquidityHook,
    TotalWinningHook,
    TotalVolumeHook,
    JackpotHook,
    baughtBackhook,
    TotalRewardhook,
  };
};

export default TotalLiquidity;
